import { Country } from '@/models/country';
import type { AiModelContent } from '../aiLeagueTypes';
import placeholderImage from '@/assets/ai-league/placeholder.svg';

export const GEMINI_AI_CONTENT: AiModelContent = {
  id: 'gemini',
  tabLabel: 'Gemini',
  displayName: 'Gemini',
  countryList: [
    Country.FR,
    Country.AR,
    Country.GB_ENG,
    Country.ES,
    Country.UY,
    Country.CO,
    Country.TR,
    Country.SE,
    Country.NO,
    Country.CH,
  ],
  listValid: true,
  responseTimeSeconds: 60,
  imageSrc: placeholderImage,
  justificationText: `Methodology and Strategic Logic

The strategy focuses on maximizing the exponential returns of the tournament progression points (+3 to +18) by aligning the highest ranking multipliers with the most reliable elite teams.

1. Top-Heavy Seed Optimization (Ranks 1–4): The maximum allowance of four seeds is allocated entirely to the highest multipliers. France, Argentina, England, and Spain possess the deepest squads, elite tournament pedigree, and favorable group stage paths to consistently reach the semi-finals or finals, yielding massive weighted returns.
2. Value-Driven Outsider Selection (Ranks 7–8): The requirement of two outsiders is satisfied using high-quality European teams that are heavily mispriced in this tier: Türkiye (Euro 2024 quarter-finalists) and Sweden (boasting an elite frontline with Gyökeres and Isak). Positioned at mid-tier multipliers, they offer immense leverage as they are highly capable of advancing and scoring goals.
3. Goal and Progression Floor (Ranks 5, 6, 9, 10): Intermediates are selected based on high goal-scoring metrics and high-probability advancement. Uruguay and Colombia are tournament-tested sides built for deep bracket runs. Norway provides unmatched goal-scoring upside via Erling Haaland against weaker group opponents to harvest the +1 goal rule, while Switzerland represents a remarkably consistent baseline for knockout round qualification.

Key Assumptions: Top seeds will avoid early catastrophic upsets; individual world-class attackers will heavily exploit group stage mismatches to maximize raw goal points.

Biggest Risk: An early knockout failure from any of the top four seeds severely damages the total score due to the heavy reliance on the x10 to x7 multipliers.`,
};
